import { Button } from "@admin/components/atoms/Button";
import { Label } from "@admin/components/atoms/Input/Label";
import { useCurrentUserGroups } from "@admin/hooks/useCurrentUserGroups";
import { FoodAcceptanceModal } from "@admin/pages/food-management/control-points/components/Modals/FoodAcceptanceModal";
import {
  answerTexts,
  // buttonColorMap,
  FoodControlPointInstance,
  FoodControlPointInstanceDto,
  getSuppliersByCompanyId,
  InstanceStatusColorAndMeanings,
  // isWithinLast24Hours,
  Item,
  selectColor,
  StatusBgColors,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { CorrectiveActions } from "../CorrectiveActions";
import { DeleteInstanceModal } from "../DeleteInstanceModal";

interface FoodAcceptanceControlTextsProps {
  datas: {
    controlData: Item;
    instance: FoodControlPointInstanceDto;
    isNewArchitecture?: boolean;
  }[];
  callBack?: () => void;
}

export function FoodAcceptanceControlTexts({
  datas,
  callBack,
}: FoodAcceptanceControlTextsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInstance, setSelectedInstance] =
    useState<FoodControlPointInstanceDto>();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { t } = useTranslation();

  const { isSuperAdmin } = useCurrentUserGroups();

  // const onEdit = useCallback((instance: FoodControlPointInstance) => {
  //   setSelectedInstance(instance);
  //   setIsModalOpen(true);
  // }, []);

  const onDelete = useCallback((instance: FoodControlPointInstance) => {
    setSelectedInstance(instance);
    setIsDeleteOpen(true);
  }, []);

  const { data: suppliers } = useQuery({
    queryKey: ["suppliersByCompany", datas?.[0]?.controlData?.companyId],
    queryFn: () =>
      getSuppliersByCompanyId(datas?.[0]?.controlData?.companyId ?? ""),
    enabled: !!datas,
  });
  return (
    <div className="flex flex-col gap-5">
      {datas?.map((data, index) => {
        const status = InstanceStatusColorAndMeanings(t).find(
          (i) => i.type === data.instance.status,
        );

        const bgColorClass =
          StatusBgColors[
            data?.controlData?.status as keyof typeof StatusBgColors
          ];

        // const buttonColor = buttonColorMap[data?.controlData?.status];

        return (
          <div
            className={`${bgColorClass} rounded-xl`}
            key={data.controlData.controlPointInstanceId ?? "" + index}
          >
            {/* {(isSuperAdmin ||
              isWithinLast24Hours(data.instance.updatedDate)) && (
              <div className="flex flex-row justify-end">
                <Button
                  size="sm"
                  property={buttonColor}
                  onClick={() => onEdit(data.instance)}
                >
                  Edit
                </Button>
              </div>
            )} */}

            <div
              className="px-5 py-8"
              key={(data.controlData.controlPointInstanceId ?? "") + index}
            >
              <Label title={t("common.Status")}>
                <span style={{ color: status?.color }}> {status?.name} </span>
              </Label>
              <Label title={t("food.Temperature")}>
                {data.controlData.temperature === -105
                  ? t("food.Dry Food Option Label")
                  : data.controlData?.temperature}
              </Label>
              <Label title={t("food.Labeling")}>
                <div
                  style={{
                    color: selectColor(data.controlData.validateMarking),
                  }}
                >
                  {answerTexts(data.controlData.validateMarking, t)}
                </div>
              </Label>
              <Label title={t("food.Shelf Life")}>
                <div
                  style={{
                    color: selectColor(data.controlData.validateMarking),
                  }}
                >
                  {answerTexts(data.controlData.validateExpirety, t)}
                </div>
              </Label>
              <Label title={t("food.Undamaged Packaging")}>
                <div
                  style={{
                    color: selectColor(data.controlData.validateMarking),
                  }}
                >
                  {answerTexts(data.controlData.validatePackaging, t)}
                </div>
              </Label>
              <Label title={t("food.Visual Quality Inspection")}>
                <div
                  style={{
                    color: selectColor(data.controlData.validateMarking),
                  }}
                >
                  {answerTexts(data.controlData.validateQuality, t)}
                </div>
              </Label>
              <Label title={t("food.Temperature Check")}>
                <div
                  style={{
                    color: selectColor(data.controlData.validateMarking),
                  }}
                >
                  {answerTexts(data.controlData.validateTemperature, t)}
                </div>
              </Label>
              <Label title={t("food.Name of the Product")}>
                {data.controlData.goodsName}
              </Label>
              <Label title={t("food.Name of the Supplier")}>
                {
                  suppliers?.find(
                    (supplier) => supplier.id === data.controlData.supplierId,
                  )?.name
                }
              </Label>
              {data.instance.remark && (
                <Label title={t("food.Remarks")}>{data.instance.remark}</Label>
              )}
              {data.instance.reason && (
                <Label title={t("food.Corrective Action")}>
                  <CorrectiveActions correctiveActions={data.instance.reason} />
                </Label>
              )}
              <div
                className={`w-2 h-2 ${
                  data.isNewArchitecture ? "bg-green-500" : "bg-red-500"
                } rounded-full inline-block`}
              ></div>
            </div>
            {isSuperAdmin && (
              <div className="flex flex-row justify-end">
                <Button
                  size="sm"
                  property="danger"
                  onClick={() => onDelete(data.instance)}
                >
                  {t("common.Delete")}
                </Button>
              </div>
            )}
          </div>
        );
      })}

      {selectedInstance && (
        <>
          <FoodAcceptanceModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            foodControlPointInstance={selectedInstance}
            initialData={JSON.parse(selectedInstance?.data || "{}")}
          />
          <DeleteInstanceModal
            open={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            selectedInstance={selectedInstance}
            callBack={callBack}
          />
        </>
      )}
    </div>
  );
}
